import { message } from "antd";
import { userApi } from "./userApi";
import { campaignApi } from "./campaignApi";
import { influencerApi } from "./influencerApi";
import { companyApi } from "./companyApi";
import { noticeApi } from "./noticeApi";
import { agencyApi } from "./agencyApi";
import { dashboardApi } from "./dashboardApi";
import { paymentApi } from "./paymentApi";

// 공통 에러 핸들링 함수
export function handleApiError(err, defaultMessage = "요청에 실패했습니다.") {
  console.error(err);

  if (err.code === "NETWORK_ERROR" || err.message?.includes("Network Error")) {
    message.error(
      "네트워크 연결을 확인해주세요. 인터넷 연결 상태를 점검해주세요."
    );
  } else if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
    message.error("요청 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.");
  } else if (err.response?.status === 500) {
    message.error("서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
  } else if (err.response?.status === 404) {
    message.error("요청한 서비스를 찾을 수 없습니다. 관리자에게 문의해주세요.");
  } else if (err.response?.status === 429) {
    message.error("너무 많은 요청이 발생했습니다. 잠시 후 다시 시도해주세요.");
  } else if (err.response?.status === 409) {
    message.error("이미 존재하는 계정입니다. 다른 이메일을 사용해주세요.");
  } else {
    message.error(defaultMessage);
  }
}

export const Api = {
  ...userApi,
  ...campaignApi,
  ...influencerApi,
  ...companyApi,
  ...noticeApi,
  ...agencyApi,
  ...dashboardApi,
  ...paymentApi,
};
